import { render, staticRenderFns } from "./hrModifyAbout.vue?vue&type=template&id=705b90d8&scoped=true"
import script from "./hrModifyAbout.vue?vue&type=script&lang=js"
export * from "./hrModifyAbout.vue?vue&type=script&lang=js"
import style0 from "./hrModifyAbout.vue?vue&type=style&index=0&id=705b90d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705b90d8",
  null
  
)

export default component.exports